export interface DocScope {
    featureId: string;
    userStoryId: string | undefined;
}

interface ScopeSource {
    level?: string | null;
    feature_id?: string | number | null;
    user_story_id?: string | null;
}

/**
 * Single source of truth for a document's feature/user-story scope.
 *
 * Work products arrive with inconsistent shapes: items from
 * /api/workproducts/activeworkproductlistings carry user_story_id but no
 * level field, while objects stamped by workProductHandlers carry both.
 * When level is absent we fall back to the ids that are present rather
 * than dropping the scope (a missing level must not disable story-scoped
 * features like the Jira/DevOps SyncPanel).
 */
export function deriveDocScope(
    workProduct: ScopeSource | null | undefined,
    featureId: string | number | undefined,
    userStoryId: string | undefined
): DocScope {
    const declaredLevel = String(workProduct?.level || "").trim().toUpperCase();
    const scopedFeatureId = workProduct?.feature_id ?? featureId;
    const featureValue = scopedFeatureId === undefined || scopedFeatureId === null || scopedFeatureId === "" ? "" : String(scopedFeatureId);
    const userStoryValue = userStoryId || workProduct?.user_story_id || undefined;

    if (declaredLevel === "PRODUCT") {
        return { featureId: "", userStoryId: undefined };
    }
    if (declaredLevel === "FEATURE") {
        return { featureId: featureValue, userStoryId: undefined };
    }
    return { featureId: featureValue, userStoryId: userStoryValue };
}
